module.exports = __webpack_public_path__ + "b4ce88240ba78e46d6d38cc2d1be963c.pdf";